import { api, commonApiWrapper } from "@/services/common-api";
import { IFinancialAccount, IProfile, IUpdateProfilePayload } from "@/app/dashboard/models/User";

export const getProfile = async () => commonApiWrapper<IProfile>(api.get('user/profile'));

export const updateProfile = async (profile: IUpdateProfilePayload) => commonApiWrapper<IProfile>(api.patch('user/update/image/profile', profile, {
    headers: { 'Content-Type': 'multipart/form-data' }
}));

export const updateUser = async (userData: {
    firstName: string;
    lastName: string;
    contactNumber: string;
    address?: string;
    dateOfBirth?: string;
    isPhoneValidated?: boolean;
}) => commonApiWrapper<IProfile>(api.patch('user/update/profile', userData));

export const getFinancialDetails = async () => commonApiWrapper<IFinancialAccount>(api.get('payments/financial-account'));
export const createFinancialAccount = async () => commonApiWrapper<IFinancialAccount>(api.post('payments/financial-account'));
